export const settingsKeys = {
  all: ['user-settings'] as const,

  transactions: () => [...settingsKeys.all, 'transactions'] as const,

  client: (clientId: number) => [...settingsKeys.all, 'client', clientId] as const,

  notificationRules: () => [...settingsKeys.all, 'rules'] as const,

  apiKeys: (userId: number | 'self') => [...settingsKeys.all, 'apikeys', userId] as const,
};
